import request from '@/service/request';

export const agentOnboard = (params: any) => {
  const { search } = window.location;
  return request.post('/v1/agency-platform-vn-v2/noAuth/agents', {
    data: params,
    headers: {
      'Device-Platform': search === '?fromPc=2' ? 'App' : 'Web',
    },
  });
};

export const sendEmailOtp = (params: { email: string; platform: string }) => {
  return request(`/v1/admin_account/login/email_verification/send_code`, {
    method: 'post',
    data: params,
  });
};

export const checkOtpCode = (params: { email: string; code: string }) => {
  return request(`/v1/admin_account/login/email_verification/check_code`, {
    method: 'post',
    data: params,
  });
};

export const updateEmail = (params: { email: string }) => {
  return request(`/v1/agency-platform-vn-v2/agency/user_info/email`, {
    method: 'put',
    data: params,
  });
};
